import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_get_inventory_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { paging?: { page: number, total: number }, warehouse: string, filters?: { owner?: string, project?: string, material?: string, lot?: string, vendor_lot?: string, upc?: string }, output_weight_uom?: string }): Promise<{ paging?: { total_records?: number, total_pages?: number, page?: number, returned_records?: number }, results?: { owner?: string, project?: string, material?: string, packaging?: string, vendor_lot?: string, lot?: string, license_plate?: string, is_fixed_weight?: boolean, packaging_net_weight?: number, packaging_gross_weight?: number, total_net_weight?: number, total_gross_weight?: number, weight_uom?: string, serial_numbers?: { lookup?: string, net_weight?: string, gross_weight?: string, weight_uom?: string }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.warehouse)) {
      $missingRequiredInParams.push('\'warehouse\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

